import { Component, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { TranslateService } from '@ngx-translate/core';
import { AuthUser } from 'src/app/models/auth/AuthUser';
import { RolesEnum } from 'src/app/models/users/roles/enums/roles';
import { ListDataFilter } from 'src/app/models/workflow-setting/list-data-filter';
import { WorkFlowSettingDelete, WorkFlowSettingList } from 'src/app/models/workflow-setting/workflow-setting-list';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { WorkFlowSettingService } from 'src/app/services/work-flow-setting.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-work-flow-setting',
  templateUrl: './work-flow-setting.component.html',
})
export class WorkFlowSettingComponent {
  constructor(
    private auth: AuthenticationService,
    public translate: TranslateService,
    private service: WorkFlowSettingService
  ) {
    this.currentUser = this.auth.currentUserValue;
  }

  /* this code will help you to refresh pagination  */
  private paginator!: MatPaginator;
  private sort!: MatSort;

  pageCount = 0;
  pageIndex = 0;
  showSearch = false;
  dataLoading = false;
  currentUser = new AuthUser();
  actions = RolesEnum;
  recordsData: WorkFlowSettingList[] = [];
  dataSource = new MatTableDataSource<WorkFlowSettingList>([]);
  filterModel: ListDataFilter = new ListDataFilter();
  displayedColumns: string[] = [
    'orgName',
    'whName',
    'workflowType',
    'workflowName',
    'fullName',
    'action',
  ];

  ngOnInit() {
    this.getAll(null);
  }

  @ViewChild(MatSort, { static: false }) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setPaginationAndSort();
  }

  @ViewChild(MatPaginator, { static: false }) set matPaginator(
    mp: MatPaginator
  ) {
    this.paginator = mp;
    this.setPaginationAndSort();
  }

  setPaginationAndSort() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  getAll(event: any) {
    this.filterModel.PageSize = 10;
    this.filterModel.TenantId = this.currentUser.user.tenantId;
    this.dataLoading = true;
    this.service.getAll().subscribe(
      (data: WorkFlowSettingList[]) => {
        this.dataLoading = false;
        if (data) {
          this.recordsData = data as WorkFlowSettingList[];
          this.dataSource = new MatTableDataSource(data);
          this.setPaginationAndSort();
        }
      },
      (error: any) => {
        this.dataLoading = false;
      }
    );
  }

  deleteRecord(rowData:any) {
    Swal.fire({
      title: this.translate.instant('swalMsg.are_you_sure'),
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: this.translate.instant('swalMsg.yes_delete_it'),
      cancelButtonText: this.translate.instant('swalMsg.no_keep_it'),
    }).then((result) => {
      if (result.value) {
        this.dataLoading = true;
        const data = {
          organizationID:rowData.organizationID,
          workFlowSource:rowData.workFlowSource,
          warehouseID:rowData.warehouseID
        } as WorkFlowSettingDelete
        this.service.deleteRecord(data).subscribe(
          (data) => {
            // console.log(data);
            this.dataLoading = false;
            this.getAll(null);

            Swal.fire({
              title: this.translate.instant('swalMsg.success'),
              text: '',
              icon: 'success',
              confirmButtonText: this.translate.instant('swalMsg.ok'),
            });
          },
          (error) => {
            this.dataLoading = false;
            Swal.fire({
              title: this.translate.instant('swalMsg.Failed'),
              text: error.title,
              icon: 'error',
              confirmButtonText: this.translate.instant('swalMsg.ok'),
            });
          }
        );
      }
    });
  }

  makeSearch() {
    if (!this.showSearch) {
      this.showSearch = true; // Show input
    } else {
      if (this.filterModel.search) {
        this.applyFilter();
      }
    }
  }

  applyFilter() {
    const filterValue = this.filterModel.search;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  resetSearch() {
    this.filterModel.search = '';
    this.applyFilter();
  }

  hasPermission(permission: string) {
    return this.auth.hasPermission(permission);
  }
}
